"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _ToolbarComponent = _interopRequireDefault(require("./ToolbarComponent"));
var _Icon = require("@gogame/ui/Icon");
var _IconButton = _interopRequireDefault(require("@gogame/ui/IconButton"));
var _Stack = _interopRequireDefault(require("@gogame/ui/Stack"));
var _Typography = _interopRequireDefault(require("@gogame/ui/Typography"));
var _styles = require("@gogame/ui/styles");
var _xDataGrid = require("@mui/x-data-grid");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      position: 'relative'
    }
  };
});
var dataCySelectableRowToolbar = 'SelectableRowToolbar';
var SelectableToolbarComponent = function SelectableToolbarComponent(_ref) {
  var children = _ref.children,
    onUnselectAll = _ref.onUnselectAll,
    label = _ref.label;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ToolbarComponent["default"], {
    "data-cy": dataCySelectableRowToolbar,
    sx: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
      direction: 'row',
      spacing: 2,
      alignItems: 'center',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
          icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.CloseIcon, {}),
          onClick: onUnselectAll,
          tooltip: 'Unselect all',
          sx: {
            ml: -2
          }
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
        variant: 'subtitle1',
        children: label
      })]
    }), children]
  });
};
var _default = exports["default"] = SelectableToolbarComponent;